import { Instance } from 'mobx-state-tree';
import model from './model';
import views from './views';

const OrganizationAddress = model.views(views);

export interface IOrganizationAddress extends Instance<typeof OrganizationAddress> {}

export default OrganizationAddress;
